import { Component } from '@angular/core';

@Component({
  selector: 'app-activation-error',
  template: `
    <div class="error-message">
      <h2>❌ Activation Error</h2>
      <p>The activation link is invalid or has expired.</p>
      <p>Please request a new activation email or contact support.</p>
    </div>
  `,
  styles: [`
    .error-message {
      text-align: center;
      padding: 50px;
      color: #dc3545;
    }
  `]
})
export class ActivationErrorComponent { }